<style lang="scss" scoped>
    .content {
        left: 0;
        width: 100% !important;
    }

    .dashboard-section {
        background-image: url("../assets/images/register-img.jpg");
        font-family: "Open Sans";
        position: relative;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        padding: 0px;
        width: 100%;
    }

    .overlay {
        color: #fff;
        background-color: rgb(0, 59, 113, 0.8);
        width: 100%;
        height: 100%;
        z-index: 1;
        text-align: center;
        padding: 50px 0px;
    }

    .m-b-5 {
        margin-bottom: 5px;
    }

    .myAmpleon .main .container {
        width: auto;
    }

    .registration-wrapper-row {
        display: flex;
        flex-wrap: wrap;
        margin: 0;
    }

    .header-content {
        /*margin: 0 100px;*/
        padding-top: 0;
        display: inline-block;
    }

    .page-title {
        border-bottom: 1px solid #ffffff;
        /*margin-bottom: 50px;*/
        margin-top: 30px;
        text-align: left;
        //margin-right: 20px;
    }

    .header-content .box-group .box:nth-child(6) {
        @media (min-width: 1436px) {
            margin-right: 0;
        }
    }

    .box-group {
        // displays 3 items of 220px until there is enough space for the 6 items in line -20
        @media (max-width: 1460px) {
            max-width: 700px;
            text-align: left;

            :nth-child(3n+3) {
                .box {
                    margin-right: 0;
                }
            }
        }

        :last-child {
            .box {
                margin-right: 0;
            }
        }
    }

    .box {
        position: relative;
        flex: 1;
        background-color: white;
        width: 220px;
        height: 220px;
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        margin-top: 29px;

        .box-img {
            height: 80px;
        }

        .box-title {
            color: #003B71;
            font-size: 14px;
            text-align: center;
            font-weight: bold;
            line-height: 20px;
        }
    }

    /*Responsive design*/

    @media (max-width: 767px) {
        .navbar {
            margin-left: 0 !important;
        }
        .registration-wrapper-row .image-section {
            height: 402px;
        }

        .box {
            flex-direction: row;
            height: 70px;
            align-items: center;
            justify-content: flex-start;
            margin: 0px;
            width: 100%;

            .box-image {
                height: 30px;
                margin-right: 10px;
            }

            .box-title {
                border-left: 1px solid #0d3349;
                padding-left: 15px;
                line-height: 44px;

            }
        }
    }

    @media (max-width: 992px) {

        .header-content {
            padding: 20px;
        }

        .page-title {
            padding-left: 0 !important;
        }

        .image-section {
            order: 1;
            height: 464px;
            width: 100%;
        }

    }

    #wrap .navbar {
        position: fixed;
        top: 0;
        width: 100%;
    }

    /* Portrait mode in iPad Pro*/
    @media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
        .box-group {
            width: 900px;
        }
    }

    .header-content .title-main {
        color: #FFFFFF !important;
    }
</style>

<template>

    <div class="registration-wrapper">

        <div id="top-bar" class="top-bar"></div>

        <div class="row registration-wrapper-row">
            <div class="col-md-12 col-sm-12 dashboard-section">
                <div class="overlay">
                    <div class="header-content">
                        <h3 class="page-title title-main">My Dashboard</h3>
                        <div class="box-group">
                            <router-link :to="{path: '/my-parametric-search'}">
                                <div class="box box-parametric-search">
                                    <img class="box-img" src="../assets/images/parametric_search.png">
                                    <h4 class="box-title box-title-ps">My Parametric Search</h4>
                                </div>
                            </router-link>

                            <router-link :to="{path: '/my-documents'}">
                                <div class="box box-documentation">
                                    <img class="box-img" src="../assets/images/Documentation.png">
                                    <h4 class="box-title box-title-documentation">My Documentation</h4>
                                </div>
                            </router-link>

                            <router-link :to="{path: '/my-subscription'}">
                                <div class="box box-subscription">
                                    <img class="box-img" src="../assets/images/Subscriptions.png">
                                    <h4 class="box-title box-title-subscription">My Subscriptions</h4>
                                </div>
                            </router-link>

                            <router-link :to="{path: '/my-account'}">
                                <div class="box box-account">
                                    <img class="box-img" src="../assets/images/Account.png">
                                    <h4 class="box-title box-title-account">My Account</h4>
                                </div>
                            </router-link>

                            <router-link :to="{path: '/my-support'}">
                                <div class="box box-support">
                                    <img class="box-img" src="../assets/images/Support.png">
                                    <h4 class="box-title box-title-support">My Support</h4>
                                </div>
                            </router-link>
                            <router-link :to="{path: '/my-admin'}">
                                <div v-if="isAdmin" class="box box-admin">
                                    <img class="box-img" src="../assets/images/Admin.png">
                                    <h4 class="box-title box-title-support">My Admin</h4>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {mapGetters} from "vuex";
    import {FETCH_PRODUCTS, LOGOUT_USER} from "../store/actions.type";
    import TopBar from "./TopBar";

    export default {
        name: "Dashboard",
        computed: {
            ...mapGetters(["isAdmin"]),
        },
        methods: {
            openMenu() {
                const menuItems = document.getElementById('menu-items');
                menuItems.classList.add('menu-layout');
            },
            logout() {
                this.$store.dispatch(LOGOUT_USER);
            }
        }
    };
</script>

